import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  width: 360px;
  margin: 0 auto;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
export const ItemList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;

  ${({ theme }) => theme.media.mobile} {
    padding: 0 20px;
  }
`;
export const Item = styled.li`
  background: ${({ theme }) => theme.colors.magenta100};

  border-radius: 999px;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.magenta700};

  ${getFontStyle('midium150_C1')};
`;

export const NoData = styled.div`
  width: fit-content;
  background: ${({ theme }) => theme.colors.gray300};
  border-radius: 999px;

  color: ${({ theme }) => theme.colors.gray650};
  padding: 8px 16px;

  ${getFontStyle('midium150_C1')};
`;
